// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__tabsContainer--jaG_X {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.style__tabsContainerInitialOverflow--hLt2_ {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: initial;
}
.style__tab--YTYqT {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-radius: 0.5rem;
  gap: 0.5rem;
  height: 3rem;
  color: #18191b;
}
.style__tab--YTYqT:hover, .style__tab--YTYqT:focus {
  background-color: #e5f9ff;
  color: #18191b;
}
.style__tabSelected--mHI8k {
  background-color: #b3ecff;
  color: #18191b;
}
.style__tabs--zcxoy {
  display: flex;
  flex-shrink: 0;
  gap: 1rem;
  width: 100%;
}
.style__content--BDLCd {
  height: 100%;
  overflow-y: auto;
}
.style__contentPadding--QXF_C {
  padding: 2rem;
}
.style__storybookTabs--vlABt {
  position: fixed;
  overflow-y: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.style__badge--x2PDp {
  background-color: #1aa6da;
  color: #fff;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Tabs/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAHJ;AAHA;EAUI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAJJ;AATA;EAiBI,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AALJ;AAOI;EAEE,yBAAA;EACA,cAAA;AALN;AAQI;EACE,yBAAA;EACA,cAAA;AANN;AA7BA;EAwCI,aAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;AARJ;AAnCA;EA+CI,YAAA;EACA,gBAAA;AATJ;AAvCA;EAoDI,aAAA;AAVJ;AA1CA;EAwDI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAXJ;AAlDA;EAiEI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .tabsContainer {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n  }\n\n  .tabsContainerInitialOverflow {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: initial;\n  }\n\n  .tab {\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    padding: @spacing-100;\n    border-radius: @spacing-50;\n    gap: @spacing-50;\n    height: @spacing-300;\n    color: @color-asphalt-grey-010;\n\n    &:hover,\n    &:focus {\n      background-color: @color-light-blue-099;\n      color: @color-asphalt-grey-010;\n    }\n\n    &Selected {\n      background-color: @color-light-blue-095;\n      color: @color-asphalt-grey-010;\n    }\n  }\n\n  .tabs {\n    display: flex;\n    flex-shrink: 0;\n    gap: @spacing-100;\n    width: 100%;\n  }\n\n  .content {\n    height: 100%;\n    overflow-y: auto;\n  }\n\n  .contentPadding {\n    padding: @spacing-200;\n  }\n\n  .storybookTabs {\n    position: fixed;\n    overflow-y: hidden;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .badge {\n    background-color: @color-light-blue-060;\n    color: @color-white;\n    border-radius: 50%;\n    width: @spacing-200;\n    height: @spacing-200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsContainer": `style__tabsContainer--jaG_X`,
	"tabsContainerInitialOverflow": `style__tabsContainerInitialOverflow--hLt2_`,
	"tab": `style__tab--YTYqT`,
	"tabSelected": `style__tabSelected--mHI8k`,
	"tabs": `style__tabs--zcxoy`,
	"content": `style__content--BDLCd`,
	"contentPadding": `style__contentPadding--QXF_C`,
	"storybookTabs": `style__storybookTabs--vlABt`,
	"badge": `style__badge--x2PDp`
};
export default ___CSS_LOADER_EXPORT___;
